export var EmailBlockTypeEnum;
(function (EmailBlockTypeEnum) {
    EmailBlockTypeEnum["BUTTON"] = "button";
    EmailBlockTypeEnum["TEXT"] = "text";
})(EmailBlockTypeEnum || (EmailBlockTypeEnum = {}));
export var TextAlignEnum;
(function (TextAlignEnum) {
    TextAlignEnum["CENTER"] = "center";
    TextAlignEnum["LEFT"] = "left";
    TextAlignEnum["RIGHT"] = "right";
})(TextAlignEnum || (TextAlignEnum = {}));
